import { catalogueDuSuivi, type CatalogueDuSuivi } from '@taki/data-model';
import type { MessageVue, PortDeFil } from '@taki/ui';
import type { ShellAppEntry } from '../types.js';

/**
 * LE SUIVI D'UNE FICHE EN MOTS DANS LE CENTRE (lot Q du chantier
 * `fiche-suivi`, 27/10/2026). Le fil du centre montre un evenement systeme par
 * son TEXTE ; un ANCIEN message, ecrit avant que le serveur ne mette ses
 * changements en mots, disait « Status : aFaire -> enCours » quand le volet de
 * la fiche disait « Étape : À faire -> En cours ». Le centre le remet en mots
 * par LA MEME REGLE que le serveur et le volet (`messageDuSuiviEnMots`,
 * `packages/data-model/src/suivi-mots.ts`, que l'app Canaux appelle aussi),
 * avec le catalogue de la fiche : aucune seconde regle de texte ici,
 * seulement de quoi trouver ce catalogue. Le shell le donne aussi aux apps par
 * le port de navigation (`catalogueDuSuivi`, `TakiShell.tsx`), avec les memes
 * deux fonctions ci-dessous : Canaux trouve le meme catalogue que le centre.
 */

/** Une declaration lue : `{ champs, ecrans }`, celle de l'org (instance) ou du modele. */
export interface DeclarationLue {
  champs: unknown;
  ecrans: unknown;
}

/**
 * LA DECLARATION DE L'APP, comme l'hote la monte : l'instance de l'org d'abord
 * (`useDeclarationsPort().instances`), le modele du bundle sinon. `null` : une
 * app sans declaration (Canvas, outil), ou inconnue.
 */
export function declarationDeLApp(
  appId: string,
  entrees: readonly Pick<ShellAppEntry, 'id' | 'declaration'>[],
  instances?: ReadonlyMap<string, DeclarationLue> | null,
): DeclarationLue | null {
  const instance = instances?.get(appId);
  if (instance !== undefined) return { champs: instance.champs, ecrans: instance.ecrans };
  const modele = entrees.find((entree) => entree.id === appId)?.declaration;
  return modele === undefined ? null : { champs: modele.champs, ecrans: modele.ecrans };
}

/** Le catalogue de la fiche (famille et type) dans la declaration de l'app qui la montre, ou `null`. */
export function catalogueDeLaFiche(
  declaration: DeclarationLue | null,
  family: string,
  type: string | null,
): CatalogueDuSuivi | null {
  return declaration === null ? null : catalogueDuSuivi([declaration], { family, type });
}

/**
 * LE PORT DU FIL, MESSAGES EN MOTS : la lecture (`observerConversation`,
 * `observerFil`) passe chaque message par `enMots` (`messageDuSuiviEnMots`) ;
 * l'ecriture et les reactions sont celles du port d'origine.
 */
export function portDuFilEnMots(port: PortDeFil, enMots: (message: MessageVue) => MessageVue): PortDeFil {
  return {
    ...port,
    observerConversation: (id, options, onChange, onError) =>
      port.observerConversation(id, options, (messages, meta) => onChange(messages.map(enMots), meta), onError),
    observerFil: (id, parentId, onChange, onError) =>
      port.observerFil(id, parentId, (messages) => onChange(messages.map(enMots)), onError),
  };
}
